<template>
  <el-row :gutter="20" class="news_announcement">
    <div class="news">
      <el-col :span="16">
        <el-row>
          <div class="grid-content bg-purple">
            <h2>
              <el-divider id="divider3" direction="vertical"></el-divider>
              <span>
                {{ msg1 }}
                <a href="/#/active"><i class="el-icon-d-arrow-right"></i></a>
                <br />
                {{ msg2 }}
              </span>
            </h2>
            <ul v-for="item in listContent" :key="item.id">
              <li>
                <el-card id="control-card">
                  <a :href="listUrl + item.id">{{ item.title }}</a>
                </el-card>
              </li>
            </ul>
          </div>
        </el-row>
      </el-col>
      <el-col :span="8">
        <el-row>
          <div class="grid-content bg-purple">
            <h2>
              <el-divider id="divider3" direction="vertical"></el-divider>
              <span>
                {{ msg3 }}
                <br />
                {{ msg4 }}
              </span>
            </h2>
          </div>
        </el-row>
      </el-col>
    </div>
  </el-row>
</template>

<script>
import getArticleList from "../utils/getArticleList";

export default {
  name: "Divider3",
  data() {
    return {
      msg1: "新闻中心",
      msg2: "NEWS",
      msg3: "公告",
      msg4: "ANNOUNCEMENT",
      listContent: [],
      listTitle: "",
      listUrl: ""
    };
  },
  created() {
    getArticleList(this.$http, "/dingyang/get-articles", "", "", "2", "8").then(
      articleList => {
        this.listContent = articleList.data.data;
        this.listTitle = "新闻中心";
        this.listUrl = "/#/active/";
      }
    );
  }
};
</script>

<style scoped>
.el-divider--vertical {
  height: 70px;
  border: 1px solid #97b9ff;
  background-color: #97b9ff;
}

span {
  vertical-align: middle;
  display: inline-block;
}

.news {
  display: block;
  margin: 0 auto;
  width: 80%;
  height: 100%;
  position: relative;
}

.el-col {
  min-width: 200px;
  padding-left: 0px !important;
  display: flex;
}

.news-row {
  padding-top: 10px;
}

.news_announcement {
  margin-bottom: 20px;
}

ul {
  padding: 0;
}
ul li a {
  color: rgb(48, 47, 47);
}

ul li {
  list-style-type: none;
  text-align: left;
  padding-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/divider3.vue